import { SEO } from 'app/components/SEO'
import { Props as StructuredDataProps } from 'app/components/StructuredData'
import { Props as FooterProps } from 'app/containers/Footer'
import { Props as HeaderProps } from 'app/containers/Header'
import { PageProps } from 'gatsby'
import React, { memo, Suspense } from 'react'

const Header = lazyComponent(() => import('app/containers/Header'))
const Footer = lazyComponent(() => import('app/containers/Footer'))
const Policy = lazyComponent(() => import('app/components/Policy'))
const StructuredData = lazyComponent(
  () => import('app/components/StructuredData'),
)

import { lazyComponent } from 'app/utils/customFunctions'

import { Props } from './contents'

export interface PageContext {
  id: string
  languageCode: string
  languagePrefix: string | null
  headerProps?: HeaderProps
  footerProps?: FooterProps
  structuredDataProps?: StructuredDataProps
}

export interface Context extends PageContext {
  props: Props
}

export const Head = ({ pageContext }: PageProps<void, Context>) => {
  const context = pageContext as any

  return <SEO {...context.seoProps} />
}

export default memo(function PolicyPageTemplate({
  pageContext,
}: PageProps<void, Context>) {
  const context = pageContext as any

  return (
    <Suspense fallback={null}>
      {context.headerProps ? (
        <Header
          languageCode={context.languageCode}
          languagePrefix={context.languagePrefix}
          pageID={context.id}
          variant="compact"
          {...context.headerProps}
        />
      ) : null}
      {context.paragraphProps ? <Policy {...context.paragraphProps} /> : null}
      {context.footerProps ? (
        <Footer languageCode={context.languageCode} {...context.footerProps} />
      ) : null}

      {context.structuredDataProps ? (
        <StructuredData
          languageCode={pageContext.languageCode}
          {...context.structuredDataProps}
        />
      ) : null}
    </Suspense>
  )
})
